import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './today.css';
import { getTodayEvents, getWeeklyEvents } from '../../store/events/actions';
import { getCompanies } from '../../store/employee/actions';
import { getLoggedInEmployeeById } from '../../store/employee/actions';
import Navigation from '../../components/navigation/Navigation';
import { GetTimeZone } from '../../components/common/DateTimeFormatter';
import HeaderProfile from '../../components/HeaderProfile';
import { hideLoading, showLoading } from '../../store/loading-reducer';
import PortalAlert from '../../components/portalAlert/portalAlert';
import { setScrollId } from '../../store/events/index';
export default function Today() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { siteUserId, primaryCompanyId } = useSelector(state => state.auth);
    const { todayEventNotifications, weeklyEvents } = useSelector(state => state.event);
    const { companiesList } = useSelector(state => state.employee);
    const [filter, setFilter] = useState({ companyId: (primaryCompanyId !== undefined && primaryCompanyId !== null ? primaryCompanyId : 0), timezone: GetTimeZone() });

    const initialTodayFilter = primaryCompanyId !== undefined && primaryCompanyId !== 0 ? primaryCompanyId : 0;

    const [todayFilter, setTodayFilter] = useState(initialTodayFilter);

    useEffect(() => {
        document.title = 'Today | CWP Team Connect';
        dispatch(showLoading());
        dispatch(getCompanies());
        dispatch(getLoggedInEmployeeById({ id: siteUserId }));
    }, []);

    useEffect(() => {
        dispatch(getTodayEvents(filter)).unwrap().then(() => {
            dispatch(hideLoading());
        });
        dispatch(getWeeklyEvents(filter)).unwrap().then(() => {
            dispatch(hideLoading());
        });
    }, [filter]);


    return (
        <div className="directory-wrap events-wrap">
            <div className="drawer-menu-collapse-wrap"></div>
            <Navigation />
            <div className="events-page-wrap">
                <div className="page-inner events-inner">
                    <div className="profile-wrap-outer mobile-show">
                        <HeaderProfile />
                    </div>


                    <div className="events-content-scrollable-wrap today-wrapper">
                        <div className="inner-pages-alert todays-alert">
                            <PortalAlert />
                        </div>
                        <div className="profile-wrap-outer">
                            <HeaderProfile />
                        </div>
                        <div className="events-header-wrap hrbenefits-header-wrap">

                            <div className="events-header-wrap-inner">
                                <h1 className="page-title today-page-title">Today</h1>
                                <div className="filter-bars">
                                    <label>
                                        <select className="menu-wrap org-dropdown" name="slct" id="slct" value={todayFilter} onChange={(event) => {
                                            setTodayFilter(event.target.value);
                                            const selectedCompanyId = parseInt(event.target.value);
                                            setFilter({ ...filter, companyId: selectedCompanyId });
                                        }}>
                                            <option value="0">All</option>
                                            {companiesList.map(company => (
                                                <option key={company.id} value={company.id}>{company.abbreviatedName}</option>
                                            ))}
                                        </select>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div className="events-content-wrap hrbenefits-content-wrap">
                            <div className="events-content-wrap-inner">
                                <div className="events-listing-wrap hrbenefits-listing-wrap">
                                    {todayEventNotifications && todayEventNotifications.length > 0 &&
                                        todayEventNotifications.map(notification =>
                                            notification.eventLog.map(notifaicationdate => (
                                                <a
                                                    onClick={() => navigate(`/event-detail/${notification.baseId}/${notifaicationdate.id}`)}
                                                    className={`news-listing-item today-listing-item light-blue ${notifaicationdate.isEventAllDay ? 'all-day-event' : ''}`}
                                                    key={notifaicationdate.id}
                                                >
                                                    <span className="news-title-wrap">
                                                        <span className="news-title-inner">
                                                            <span className="news-day-title normal-title">
                                                                {notification.eventType?.name === 'Visitor'
                                                                    ? notification.eventType?.name
                                                                    : notification.eventType?.name}
                                                                {!notifaicationdate.isEventAllDay && notification.eventLog.length > 0 && notifaicationdate.startTime && (
                                                                    <span className="time-list">{' @ ' + notifaicationdate.startTime}</span>
                                                                )}
                                                            </span>
                                                            <span className="news-description">{notification.title}</span>
                                                        </span>
                                                    </span>
                                                </a>
                                            ))
                                        )
                                    }

                                    {todayEventNotifications && todayEventNotifications.length === 0 && (
                                        <a href="#" className="news-listing-item today-listing-item light-blue" onClick={(e) => e.preventDefault()}>
                                            <span className="news-title-wrap">
                                                <span className="news-title-inner">
                                                    <span className="news-description">No Notifications Today</span>
                                                </span>
                                            </span>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/*Week*/}
                        <div className="events-header-wrap hrbenefits-header-wrap">
                            <div className="events-header-wrap-inner">
                                <p className="page-title today-page-title no-icon">
                                    This Week
                                </p>
                            </div>
                        </div>
                        {weeklyEvents.length > 0 && weeklyEvents.map((week, index) => (
                            <div className="events-content-wrap hrbenefits-content-wrap" key={index}>
                                <div className="events-content-wrap-inner">
                                    <div className="events-listing-wrap">
                                        {week.weeklyEvents.map((event) => (
                                            event.eventLogs.map((eventlog, eventlogIndex) => (
                                                <a key={eventlogIndex} onClick={() => { dispatch(setScrollId({ scrollId: `event-${eventlog.event.baseId}-${eventlog.id}` })); navigate(`/event-detail/${eventlog.event.baseId}/${eventlog.id}`); }} id={`event-${eventlog.event.baseId}-${eventlog.id}`} className="events-listing-item">
                                                    <div className="events-date-wrap">
                                                        <div className="events-date-wrap-inner">
                                                            <span className="events-month-title"> {eventlog?.eventDay}</span>
                                                            <span className="events-day-title"></span>
                                                        </div>
                                                    </div>
                                                    <div className="events-title-wrap">
                                                        <div className="events-title-inner">
                                                            <div className="events-image-title-wrap">
                                                                <p>
                                                                    <span>{eventlog?.event?.title}</span>
                                                                </p>
                                                            </div>
                                                            <div className="events-rsvp-wrap">
                                                                <p>{eventlog?.event?.eventStartTime}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            ))
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}